<template>
  <panel :title="product.title">
    <span slot="header-right" class="badge" :class="product.original.variation.status">{{ $t(product.original.variation.status).label }}</span>
    <div class="l-row">
      <div class="l-col-12@md image">
        <img :src="image" :alt="product.title" slot="image">
      </div>
    </div>
    <div class="l-row">
      <div class="l-col-12@md">
        <span class="divider">Atributos</span>
        <span class="ds-block"><strong>SKU:</strong> {{ product.sku | attribute }}</span>
        <span class="ds-block"><strong>EAN:</strong> {{ product.ean | attribute }}</span>
        <span class="ds-block" v-if="product.brand"><strong>Marca:</strong> {{ product.brand }}</span>
        <span class="ds-block" v-if="product.color"><strong>Cor:</strong> {{ product.color }}</span>
        <span class="ds-block" v-if="product.grid"><strong>Tamanho:</strong> {{ product.grid }}</span>
        <span class="ds-block" v-if="product.flavor"><strong>Sabor:</strong> {{ product.flavor }}</span>
        <span class="ds-block" v-if="product.voltage"><strong>Voltagem:</strong> {{ product.voltage }}</span>
      </div>

      <slot/>
    </div>
  </panel>
</template>

<script>
import Panel from '@/components/template/Panel'
import Loader from '@/components/template/Loader'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  mounted () {
    if (this.product.gridType === 'voltage' && this.product.voltage === undefined) {
      this.product.voltage = this.product.grid
      this.product.grid = undefined
    }
  },
  components: {
    Panel,
    Loader
  }
}
</script>

<style lang="sass" scoped>
  .image
    text-align: center

    img
      max-width: 100%
      max-height: 180px
</style>



// WEBPACK FOOTER //
// Product.vue?9bd049ce